module.exports = __webpack_public_path__ + "img/avante.42a8e5c5.jpg";